var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 114,
    viewBox: "0 0 158 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 28.4569L138 0V85.5431L31 114V28.4569Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19.23L69 6V45.77L20 59V19.23Z",
    fill: "#2574DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 94.7443L138 91V102.256L124 106V94.7443Z",
    fill: "#D09CE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 35.7443L14 32V43.2557L0 47V35.7443Z",
    fill: "#FFA100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 82.1687C81.3031 78.9953 131.884 53.6057 155.743 6",
    stroke: "#241F20",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 82.5H155",
    stroke: "#241F20",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3864 38.6983L52.7363 28.3482C53.0878 27.9968 53.0878 27.4269 52.7363 27.0755L51.4636 25.8027C51.1121 25.4512 50.5422 25.4512 50.1908 25.8027L41.75 34.2435L37.8092 30.3026C37.4577 29.9512 36.8878 29.9512 36.5364 30.3026L35.2636 31.5754C34.9121 31.9269 34.9121 32.4968 35.2636 32.8482L41.1136 38.6982C41.465 39.0497 42.0349 39.0497 42.3864 38.6983Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 83V18",
    stroke: "#241F20",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 82V63",
    stroke: "#241F20",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 83V51",
    stroke: "#241F20",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 83V37",
    stroke: "#241F20",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngageLogo);
export default __webpack_public_path__ + "static/media/engage-logo.771c3b35105591d0a9f31f1f1e936977.svg";
export { ForwardRef as ReactComponent };